module.exports = __webpack_public_path__ + "static/media/yellowUncheck.38fc2356.svg";